const formatDateAndTime = (dateString: string) => {
    if (!dateString) return { date: "", time: "" };

    const cleanedDateString = dateString.replace(/\[.*?\]$/, "");
    const date = new Date(cleanedDateString);

    if (isNaN(date.getTime())) return { date: "", time: "" };

    const dateFormatted = date.toLocaleDateString("nl-NL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });

    const timeFormatted = date.toLocaleTimeString("nl-NL", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    });

    return { date: dateFormatted, time: timeFormatted };
};

export default formatDateAndTime;
